// src/routes/AdminRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DgLayout from '../layouts/DgLayout';
import DemandeList from '../pages/DG/DemandeList';
import DemandeDetail from '../pages/DG/DemandeDetail';


const DgRoutes = () => (
  <Routes>
    <Route path="/" element={<DgLayout />}>
      <Route index element={<DemandeList />} />
      <Route path="demande" element={<DemandeList />} />
      <Route path="demande/:id" element={<DemandeDetail />} />
    </Route>
  </Routes>
);

export default DgRoutes;
